/**
 * Rooms API service
 */
import { apiClient as api } from '@/shared/utils/api';

export interface Room {
  room_id: string;
  room_name: string;
  room_number: string;
  department_id?: string;
  department_name?: string;
  is_active?: boolean;
}

export interface RoomsResponse {
  rooms?: Room[];
  results?: Room[];
  data?: Room[];
}

class RoomsService {
  async getRooms(): Promise<{ data: Room[] }> {
    const response = await api.get<RoomsResponse>('/facilities/rooms/');

    // Handle different response formats
    const rooms = response.data.rooms ||
                 response.data.results ||
                 response.data.data ||
                 (Array.isArray(response.data) ? response.data : []);

    return { data: rooms };
  }

  async getRoom(id: string): Promise<{ data: Room }> {
    const response = await api.get<Room>(`/facilities/rooms/${id}`);
    return { data: response.data };
  }
}

export const roomsService = new RoomsService();
export default roomsService;
